import { makeStyles } from "@material-ui/styles";

const MAX_BLOCK_WIDTH = 400

export default makeStyles(theme => {
    const doubleWidth = MAX_BLOCK_WIDTH * 2
    return ({
        crusher: {
            maxWidth: doubleWidth
        },
        buttons: {
            zIndex: 1,
            position: "fixed",
            display: "flex",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: theme.palette.background.paper,
            borderTop: `solid 1px ${theme.palette.divider}`,
            justifyContent: "center",
            "& > div": {
                margin: `${theme.spacing(2)}px 0 ${theme.spacing(2)}px 225px`,
                maxWidth: MAX_BLOCK_WIDTH << 1,
                width: "100%",
                textAlign: "right",
                "& > button:first-child":{
                    marginRight: theme.spacing(1)
                }
            }
        },
        infoTab: {
            marginBottom: theme.spacing(4)
        },
        textField: {
            margin: theme.spacing(1, 0)
        },
        block: {
            "& h3": {
                margin: theme.spacing(1),
                color: theme.palette.text.disabled,
                "& > button": {
                    float: "right"
                }
            },
            "& .MuiAccordionDetails-root":{
                padding: 0
            }
        },
        notes: {
            maxWidth: doubleWidth
        },
        addDevice: {
            padding: theme.spacing(2, 1)
        },
        [theme.breakpoints.up('sm')]:{
            leftBlock: {
                paddingRight: `${theme.spacing(3)}px !important`
            },
            rightBlock: {
                paddingLeft: `${theme.spacing(3)}px !important`
            }
        },
        [theme.breakpoints.down('sm')]: {
            buttons: {
                "& > div": {
                    margin: theme.spacing(2, 4)
                }
            },
        },
        [theme.breakpoints.down('xs')]: {
            buttons: {
                "& > div": {
                    maxWidth: "initial"
                }
            },
            notes: {
                maxWidth: "initial"
            }
        },
        qrCodeTextField: {
            "& svg": {
                width: 24,
                height: 24
            }
        },
        deviceModified: {
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: `solid 2px ${theme.palette.error.main}`,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(1),
            "& > div": {
                display: "flex",
                flexGrow: 1
            },
            "& > div > p": {
                margin: theme.spacing(0, 1)
            },
            "& > div svg": {
                color: theme.palette.error.main
            }
        },
        tabs:{
            borderBottom:`solid 1px ${theme.palette.text.disabled}`,
            "& .MuiTab-root":{
                minWidth: 0,
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(1)
            },
            "& .MuiTab-wrapper":{
                whiteSpace: "nowrap"
            }
        },
        deviceIcon: {
            width: 32,
            height: 16,
            overflow: "visible",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            "& svg":{
                width: 32,
                height: 32
            }
        },
        clampedImage: {
            marginTop: theme.spacing(1),
            maxWidth: 200
        },
        components: {
            marginTop: theme.spacing(1)
        }
    })
})
